var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretGreyRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    "data-id": "caret-right",
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0002 11.9999C17.0002 12.2559 16.9022 12.5119 16.7072 12.7069L10.7072 18.7069C10.3162 19.0979 9.68416 19.0979 9.29316 18.7069C8.90216 18.3159 8.90216 17.6839 9.29316 17.2929L14.5862 11.9999L9.29316 6.70687C8.90216 6.31587 8.90216 5.68387 9.29316 5.29287C9.68416 4.90187 10.3162 4.90187 10.7072 5.29287L16.7072 11.2929C16.9022 11.4879 17.0002 11.7439 17.0002 11.9999Z",
    fill: "#C6C6C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretGreyRight);
export default __webpack_public_path__ + "static/media/caret-grey-right.0672912ccdbc4b137adb69c91906165a.svg";
export { ForwardRef as ReactComponent };